import { Skeleton } from "@coval/ui"

export function PersonaFormFieldsSkeleton() {
  return (
    <div className="space-y-4" data-testid="persona-form-fields-skeleton">
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  )
}

export function PersonaFormFieldsInitializationError() {
  return (
    <div
      role="alert"
      className="rounded-lg border border-coval-danger-border bg-coval-danger-surface p-4 text-sm text-coval-danger-text"
    >
      Persona details could not be loaded. Close and reopen this view to try
      again.
    </div>
  )
}
